import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fade, Typography } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { formatCurrency } from '../../../utils'

interface PaymentProcessingDialogProps {
  open: boolean
  state: 'processing' | 'success'
  amount: number | null
  onClose: () => void
  onContinue: () => void
}

export function PaymentProcessingDialog({ open, state, amount, onClose, onContinue }: PaymentProcessingDialogProps) {
  const formattedAmount = amount != null ? formatCurrency(amount) : ''

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={() => {
        if (state === 'success') onContinue()
        else onClose()
      }}
    >
      <DialogTitle>
        {state === 'processing' ? 'Processing Payment' : 'Payment Submitted'}
      </DialogTitle>

      <DialogContent sx={{ px: 4, pb: state === 'processing' ? 4 : 2 }}>
        {amount != null && (
          <Box sx={{ textAlign: 'center', mb: 2, mt: 1 }}>
            <Typography variant="caption" color="text.secondary">Amount</Typography>
            <Typography
              variant="h4"
              component="div"
              sx={{ fontWeight: 700, color: 'primary.main', mt: 0.5 }}
            >
              {formattedAmount}
            </Typography>
          </Box>
        )}

        {state === 'processing' ? (
          <Fade in={state === 'processing'}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 3 }}>
              <CircularProgress color="primary" sx={{ mb: 2 }} />
              <DialogContentText sx={{ fontWeight: 500, textAlign: 'left' }}>Processing your payment... This may take a few moments - please do not close this window.</DialogContentText>
            </Box>
          </Fade>
        ) : (
          <Fade in={state === 'success'}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 3 }}>
              <CheckCircleOutlineIcon color="success" sx={{ fontSize: 48, mb: 2 }} />
              <DialogContentText sx={{ fontWeight: 500, textAlign: 'center', mb: 1 }}>Payment submitted successfully!</DialogContentText>
            </Box>
          </Fade>
        )}
      </DialogContent>

      <DialogActions sx={{ pb: 2 }}>
        {state === 'success' && (
          <Button variant="contained" onClick={onContinue}>
            Continue
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
